import { IconProps } from ".";
import Icon from "./assets/education_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Education(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
